import { ROUTE_PATH_WIKI } from "page/wiki/wiki-config";

export const ROUTE_PATH_ABILITIES = `${ROUTE_PATH_WIKI}/abilities`;
